interface SkillType {
    title: string;
    icon: string;
    link: string;
}

export const skills: SkillType[] = [
    {
        title: 'Python',
        icon: 'https://s2.svgbox.net/files.svg?ic=python',
        link: 'https://www.python.org/',
    },
    {
        title: 'Java',
        icon: 'https://s2.svgbox.net/files.svg?ic=java',
        link: 'https://www.java.com/en/',
    },
    {
        title: 'JavaScript',
        icon: 'https://s2.svgbox.net/files.svg?ic=js',
        link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
    },
    {
        title: 'C#',
        icon: 'https://s2.svgbox.net/files.svg?ic=csharp',
        link: 'https://learn.microsoft.com/en-us/dotnet/csharp/',
    },
    {
        title: 'Typescript',
        icon: 'https://s2.svgbox.net/files.svg?ic=typescript-official',
        link: 'https://www.typescriptlang.org/',
    },
    {
        title: 'Expo',
        icon: 'https://s2.svgbox.net/files.svg?ic=expo',
        link: 'https://expo.dev/',
    },
    {
        title: 'React',
        icon: 'https://s2.svgbox.net/files.svg?ic=reactjs',
        link: 'https://reactjs.org/',
    },
    {
        title: 'Swift',
        icon: 'https://s2.svgbox.net/files.svg?ic=swift',
        link: 'https://developer.apple.com/swift/',
    },
    {
        title: 'Tailwind',
        icon: 'https://s2.svgbox.net/files.svg?ic=tailwind',
        link: 'https://tailwindcss.com/',
    },
    {
        title: 'Node JS',
        icon: 'https://s2.svgbox.net/files.svg?ic=node',
        link: 'https://nodejs.org/en/',
    },
    {
        title: 'Postman',
        icon: 'https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg',
        link: 'https://www.postman.com/company/about-postman/',
    },
    {
        title: 'Postgres',
        icon: 'https://s2.svgbox.net/files.svg?ic=pgsql',
        link: 'https://www.postgresql.org/',
    },
    {
        title: 'MySQL',
        icon: 'https://s2.svgbox.net/files.svg?ic=mysql',
        link: 'https://www.mysql.com/',
    },
    {
        title: 'MongoDB',
        icon: 'https://s2.svgbox.net/files.svg?ic=mongo',
        link: 'https://www.mongodb.com/',
    },
    {
        title: 'Git',
        icon: 'https://s2.svgbox.net/files.svg?ic=git',
        link: 'https://git-scm.com/',
    },
    {
        title: 'Docker',
        icon: 'https://s2.svgbox.net/files.svg?ic=docker2',
        link: 'https://www.docker.com/',
    },
];